import React from 'react';
import { Link } from 'react-router-dom';
import { TiThMenu } from 'react-icons/ti';
import { MdClose } from 'react-icons/md';

class Header extends React.Component {
  constructor() {
    super();
    this.state = {
      isactive: false
    };
  }

  handleActive = value => {
    this.setState({
      isactive: value
    });
  };

  render() {
    let { isactive } = this.state;
    return (
      <>
        {isactive ? (
          <header className="active-header">
            <div className="active-header-top">
              <li>
                <Link to="/" className="logo">
                  Learnist
                </Link>
              </li>
              <MdClose
                className="active-header-close-btn"
                onClick={() => this.handleActive(false)}
              />
            </div>
            <div className="r-nav-items-cont">
              {['sessions', 'about'].map(menuitem => (
                <a
                  href={`#${menuitem}`}
                  onClick={() => this.handleActive(false)}
                  className="r-nav-item"
                >
                  {menuitem}
                </a>
              ))}
              <a
                href=" https://discord.gg/RC6M5Us"
                target="_blank"
                rel="noopener noreferrer"
                className="r-nav-item"
                style={{ color: '#00ffa4' }}
              >
                JOIN
              </a>
            </div>
          </header>
        ) : (
          <header className="main-header wrapper r-wrapper">
            <nav>
              <div className="nav-menu">
                <li>
                  <Link to="/" className="logo">
                    Learnist
                  </Link>
                </li>
                {['sessions', 'about'].map((menuitem, idx) => (
                  <li key={idx}>
                    <a href={`#${menuitem}`} className="nav-item nav-menu">
                      {menuitem}
                    </a>
                  </li>
                ))}
                <li>
                  <a
                    href=" https://discord.gg/RC6M5Us"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="nav-item nav-menu"
                    style={{ color: '#00ffa4' }}
                  >
                    JOIN
                  </a>
                </li>
              </div>

              <TiThMenu
                className="nav-hamburger"
                onClick={() => this.handleActive(true)}
              />
            </nav>
          </header>
        )}
      </>
    );
  }
}

export default Header;
